import React, {useEffect, useState} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import Select from 'react-select'

const ProvenanceModal = (props) => {
  const {
    provenances,
    pieceToValidate,
    validateAddPanier,
    selectedProvenance,
    setSelectedProvenance,
    isLoadingProvenance = false,
  } = props


  // Seléction de provenance
  const handleProvenanceChange = (e) => {
    setSelectedProvenance(e)
  }


  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_provenance'>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              Ajout de provenance pour la pièce {pieceToValidate?.piece?.typePiece?.nom}
            </h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <Select
              className='react-select-styled react-select-solid react-select-lg'
              classNamePrefix='react-select'
              options={provenances}
              fieldName='provenance_piece'
              value={selectedProvenance.value}
              onChange={(e) => handleProvenanceChange(e.value)}
              placeholder='Sélectionner la provenance de la pièce'
              isLoading={isLoadingProvenance}
            />
          </div>
          <div className='modal-footer'>
            <button
              type='button'
              className='btn btn-sm btn-light-secondary'
              data-bs-dismiss='modal'
            >
              Annuler
            </button>
            <button
              type='button'
              className='btn btn-sm btn-light-primary'
              data-bs-dismiss='modal'
              onClick={() => validateAddPanier(pieceToValidate)}
              disabled={selectedProvenance.value == ''}
            >
              Valider le panier
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProvenanceModal